import { Container, Row } from "reactstrap";
import { ApplyButton, JobSearch } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import LeftSidebar from "../common/leftSidebar";
import ApplyForm from "./applyForm/ApplyForm";

const ApplyJobsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ApplyButton} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <ApplyForm />
        </Row>
      </Container>
    </>
  );
};
export default ApplyJobsContainer;
